import * as React from 'react';
import { Table, Alert } from 'antd';
import CommonUtils from '../../../../../utils/commonUtils';

class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      data: null, // 具体要显示的内容
      pmid_text: null, // 签名
      columns: [],
      columnData: [],
    };
  }
  UNSAFE_componentWillMount() {
    //  console.log('this.props.content', this.props.content);
    if (this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.content !== this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  // 查找要显示的内容
  findData = () => {
    let content = this.state.content;
    console.log('content: ', content);
    if (content && content.length > 0) {
      let find = content.find(v => { return v.label === 'ji_ele' });
      if (find && find.content && find.content.length > 0) {
        let find2 = find.content.find(y => { return y.label === 'ji_custom_table' });
        console.log('find2: ', find2);
        if (find2 && find2.content) {
          console.log('find2.content: ', find2.content);
          let columns = this.state.columns;
          let columnData = this.state.columnData;
          // columns.push({
          //   title: '序号',
          //   dataIndex: 'num',
          //   key: 'num',
          //   width: 60,
          //   render: (text, rec, index) => {
          //     return index + 1;
          //   }
          // });
          if (find2.content.data && find2.content.data.length > 0 && find2.content.columns && find2.content.columns.length > 0) {
            // 获取列表
            for (let index = 0; index < find2.content.columns.length; index++) {
              const colum = find2.content.columns[index];
              let obj = {
                title: colum, dataIndex: colum, key: colum, width: 100, ellipsis: true
              };
              columns.push(obj);
            }
            console.log('columns: ', columns);
            // 组装列表数据
            for (let index = 0; index < find2.content.data.length; index++) {
              const data = find2.content.data[index];
              if (data && data.length > 0) {
                let obj = {
                  id: CommonUtils.generateUUID(),
                };
                for (let index2 = 0; index2 < find2.content.columns.length; index2++) {
                  const columKey = find2.content.columns[index2];
                  if(data[index2] && typeof data[index2] === 'object') {
                    obj.expend = data[index2];  // 扩展行数据
                  }else{
                    obj[columKey] = data[index2];
                  }
                }
                columnData.push(obj);
              }
            }
            console.log('columnData: ', columnData);
          }
          this.setState({ columnData, columns: columns.slice(0, columns.length - 1) }, () => {
            console.log(this.state.columns);
          });

        }
      }
    }
  }
  render() {
    const expandedRowRender = (record, index) => {
      console.log('record: ', record);
      const { expend = []} = record;
      let data = [];
      if (expend && expend.length > 0) {
        for (let index = 0; index < expend.length; index++) {
          const elements = expend[index];
          const newElement = {};
          elements?.forEach(item => {
            const key = Object.keys(item)?.[0];
            newElement[key] = item[key];
          });
          data.push(
            {
              id: CommonUtils.generateUUID(),
              ...newElement
            }
          );
        }
      }
      console.log('data: ', data);
      const columnsEx = expend?.[0]?.map((item) => {
        const key = Object.keys(item)?.[0];
        return  {
            title: key,
            dataIndex: key,
            key: key,
            width: 60,
            render:(text, rec, index) => {
              if(text.href){
                return <a onClick={() => { window.open(text.href) }}>{text.text}</a>;
              }
              return text.text;
            }
        };
      });
      return <Table size="small" columns={columnsEx} dataSource={data} pagination={false} rowKey={(record, index) => record.id} />;
    };
    return (
      <React.Fragment>
        {this.state.columns && this.state.columns.length > 0 &&
          <div>
            <Alert
              message="Z-score值越大，代表该知识颗粒中所包含的信息越富集于该杂志。"
              type="warning"
              style={{ marginBottom: '0.2rem', fontSize: '12px'}}
            />
            <Table
              size="small"
              rowKey={(record, index) => record.id}
              columns={this.state.columns}
              expandable={{ expandedRowRender }}
              dataSource={this.state.columnData}
              pagination={false}
              expandRowByClick={true}
            />
          </div>
        }
      </React.Fragment>
    );
  }
}

export default Summary;